﻿// Import editor implementations
import { ClassicEditor as ClassicEditorBase, InlineEditor as InlineEditorBase, DecoupledEditor as DecoupledEditorBase } from 'ckeditor5';

// import default plugins and defaut config
import plugins from './plugins';
import defaultConfig from './config';
import { setToolbarByName, addToolbar } from './toolbars';

// mimic "CKEDITOR.instances" of CKEditor 4
const instances = {};
function setInstance(editor, config) {
    let instanceName = config.instanceName || editor.id;
    instances[instanceName] = editor;

    editor.on('destroy', () => {
        delete instances[instanceName];
    });
}

function initConfig(config) {
    config = config || {};
    // apply toolbar in case "toolbarName" is specified in the config
    setToolbarByName(config);

    config.licenseKey = 'dzhabStidU9DSno3cTJiMjEraThuQTJZTGxOZmdKVFdYWGlQTnFtN0ZValFrbHJSTXNhQS9rb2RMeitlWUZocS9ud05aVTN4MWc9PS1NakF5TlRBNU16QT0=';

    return config;
}

function getToolbarContainer(config) {
    if (config && config.toolbarSpace) {
        return document.getElementById(config.toolbarSpace);
    }

    return null;
}

function moveToolbar(editor, toolbarContainer, toolbar, dir, className) {
    // set "dir" and CSS classes to apply styles correctly
    toolbarContainer.dir = dir;
    toolbarContainer.className = className;
    toolbarContainer.classList.add('ck-ems-toolbar');

    toolbarContainer.appendChild(toolbar);

    editor.on('destroy', function() {
        toolbar.remove();
    });
}

function afterCreateEditor(editor, config) {
    setInstance(editor, config);

    editor.ui.focusTracker.on('change:isFocused', (evt, name, isFocused) => {
        if (isFocused) {
            editor.fire('focus');
        }
        else {
            editor.fire('blur');
        }
    });

    if (config.startupFocus) {
        editor.editing.view.focus();
    }
}

class ClassicEditor extends ClassicEditorBase {
    static builtinPlugins = plugins;
    static defaultConfig = defaultConfig;

    static async create(sourceElementOrData, config) {
        config = initConfig(config);

        let createInstance = ClassicEditorBase.create.bind(ClassicEditor)
        let editor = await createInstance(sourceElementOrData, config);

        let toolbarContainer = getToolbarContainer(config);

        // move the toolbar to the toolbarContainer in case it is specified
        if (toolbarContainer) {
            moveToolbar(
                editor,
                toolbarContainer,
                editor.ui.view.toolbar.element.parentElement.parentElement.parentElement,
                editor.ui.view.element.dir,
                editor.ui.view.element.className);
        }

        afterCreateEditor(editor, config);

        return editor;
    }
}

const inlineUnsupportedPlugins = [
    'SourceEditing',
    'Sizing'
];

class InlineEditor extends InlineEditorBase {
    static builtinPlugins = plugins.filter(p => inlineUnsupportedPlugins.includes(p.pluginName) === false);
    static defaultConfig = defaultConfig;

    static async create(sourceElementOrData, config) {
        config = initConfig(config);

        let createInstance = InlineEditorBase.create.bind(InlineEditor);
        let editor = await createInstance(sourceElementOrData, config);

        let toolbarContainer = getToolbarContainer(config);

        // move the toolbar to the toolbarContainer in case it is specified
        if (toolbarContainer) {
            let toolbar = editor.ui.view.toolbar.element;

            moveToolbar(
                editor,
                toolbarContainer,
                toolbar,
                toolbar.parentElement.parentElement.dir,
                toolbar.parentElement.parentElement.className);
        }

        afterCreateEditor(editor, config);

        return editor;
    }
}

const decoupledUnsupportedPlugins = [
    'SourceEditing',
    'Sizing'
];
class DecoupledEditor extends DecoupledEditorBase {
    static builtinPlugins = plugins.filter(p => decoupledUnsupportedPlugins.includes(p.pluginName) === false);
    static defaultConfig = defaultConfig;

    static async createInstance(element, toolbarContainer, config) {
        config = initConfig(config);

        let createInstance = DecoupledEditorBase.create.bind(DecoupledEditor);
        let editor = await createInstance(element, config);

        toolbarContainer.appendChild(editor.ui.view.toolbar.element);

        afterCreateEditor(editor, config);

        return editor;
    }
}

// all exports will be available via "CKEDITOR5"
// see 'library' in webpack config
export { ClassicEditor, InlineEditor, DecoupledEditor };
export { instances };
export { addToolbar };